<template>
  <form class="w-full bg-white" @submit.prevent="submit">
    <div class="space-y-4 p-6">
      <text-input
        :model-value="form.page.slug"
        :errors="form.errors['page.slug']"
        label="Slug"
        required
        autofocus
        placeholder="np. oferta"
        maxlength="64"
        @update:model-value="onSlugInput"
      />
      <p class="text-xs text-gray-500">
        Slug stanie się fragmentem URL strony. Spacje zamieniamy na podkreślenia, dozwolone są małe litery, cyfry, myślniki i podkreślenia. Strona będzie dostępna pod
        <code class="rounded bg-gray-100 px-1 py-0.5 text-[11px]">{{ pathPreview }}</code>.
      </p>
    </div>
    <div class="flex items-center justify-end border-t border-gray-200 bg-gray-100 px-6 py-4">
      <loading-button
        :loading="form.processing"
        class="btn-indigo"
        type="submit"
      >
        Utwórz stronę
      </loading-button>
    </div>
  </form>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { useForm } from '@inertiajs/vue3';
import LoadingButton from '@/Shared/LoadingButton.vue';
import TextInput from '@/Shared/TextInput.vue';
import { createPageRouteHelper } from '@/utils/createPageRouteHelper';

const { proxy } = getCurrentInstance();
const routes = proxy.$routes;

const props = defineProps({
  // eslint-disable-next-line vue/prop-name-casing
  site_context: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['success']);

const form = useForm({
  page: {
    slug: '',
  },
});

const pageRoutes = computed(() => createPageRouteHelper(props.site_context, routes));

const pathPreview = computed(() => {
  const slug = (form.page.slug || '').trim() || ':slug';
  return `/${pageRoutes.value.pathPrefix}/${slug}/configuration`;
});

// Mirrors Page#normalize_slug in the backend so the path preview reflects what
// the server will actually persist. Spaces collapse to a single underscore and
// the value is lowercased; other characters pass through unchanged so the user
// still sees server-side validation errors for anything genuinely invalid.
const normalizeSlug = (value) =>
  (value || '').toLowerCase().replace(/\s+/g, '_');

const onSlugInput = (value) => {
  form.page.slug = normalizeSlug(value);
};

const submit = () => {
  form.post(pageRoutes.value.create(), {
    preserveScroll: true,
    onSuccess: () => {
      if (!form.hasErrors) {
        form.reset();
        emit('success');
      }
    },
  });
};
</script>
